import { render, staticRenderFns } from "./PointDeduct.vue?vue&type=template&id=c277a164&scoped=true&lang=pug"
import script from "./PointDeduct.vue?vue&type=script&lang=js"
export * from "./PointDeduct.vue?vue&type=script&lang=js"
import style0 from "./PointDeduct.vue?vue&type=style&index=0&id=c277a164&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c277a164",
  null
  
)

export default component.exports